import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import { useUserStatus } from '../../hooks/useUserStatus';

import { userApi } from './api';
import userQueryKey from './userQueryKey';

export const useNTStatusQuery = (isEnabled = true) => {
  const { isOpen } = useAppState();
  const { isTrialOrAfterTrial } = useUserStatus();

  return useQuery({
    queryKey: userQueryKey.NTStatus(),
    queryFn: ({ signal }) => userApi.getUserNTStatus(signal),
    enabled: isOpen && isEnabled && isTrialOrAfterTrial,
  });
};
